export var gtagEvent = function (eventName, eventParams) {
  if (typeof window !== "undefined") {
    if (window.gtag) {
      console.log("gtag event", eventName, eventParams);
      window.gtag("event", eventName, eventParams);
    }
  }
};